import React, { useState } from 'react';
import CustomError from './CustomError';

/* Validation */
import { Formik } from 'formik';
import { validationSchema } from './formConfig';

/* Gjensidige Core 20 Imports */
import utils from '@gjensidige/core-utilities-css';

/* Gjensidige Core 30 Imports */
import { Alert } from '@gjensidige/core-components/lib/alerts/default';
import { Col, Row } from '@gjensidige/nci-core-grid';
import { Input } from '@gjensidige/core-components/lib/forms/input';
import { TextArea } from '@gjensidige/core-components/lib/forms/textarea';
import { Dropdown } from '@gjensidige/core-components/lib/forms/dropdown';
import { Text, Title } from '@gjensidige/nci-core-typography';
import { InputGroupSimple } from '@gjensidige/core-components/lib/forms/input-group-simple';
import { Checkbox } from '@gjensidige/core-components/lib/forms/checkbox';

/* API */
import axios from 'axios';
import { Endpoints } from '@internal/common';
import {Button} from "@gjensidige/core-components/lib/button";

export interface IProps {
  claimType: string;
}

const ClaimReportMotorVehicle: React.FC<IProps> = (props) => {
  const [formData, setFormData] = useState({
    claimType: props.claimType,
    companyName: '',
    cvrNumber: '',
    contactPersonName: '',
    email: '',
    contactPersonPhoneNumber: '',
    isMotorVehicleRegistered: '',
    registrationNumber: '',
    chassisNumber: '',
    productAndType: '',
    yearModel: '',
    rescueCorpSubscription: '',
    useAtTimeOfDamage: '',
    vehiclePartOfVATCompany: '',
    damageDetails: '',
    damageDateAndTime: '',
    sceneOfAccidentAddress: '',
    policeReportMade: '',
    policeStation: '',
    driverTookAlcoholTest: '',
    driverTookBloodTest: '',
    driversNameAndAddress: '',
    driversPhoneNumber: '',
    driverHadValidDriversLicense: '',
    driversLicenseNumber: '',
    driversLicenseDateOfIssue: '',
    driversLicenseType: '',
    speedOfVehicle: '',
    wereLightsOn: '',
    wereStreetLightsOn: '',
    accidentSiteInformed: '',
    weatherAndDrivingConditions: '',
    isVehicleDamaged: '',
    vehicleDamageDetails: '',
    wasThereOtherParty: '',
    otherPartyComeFrom: '',
    otherPartyDetails: '',
    otherPartyVehicleDamaged: '',
    otherPartyVehicleDamageDetails: '',
    otherPartySpeed: '',
    otherPartyLightsOn: '',
    whoToBlame: '',
    witnessToAccident: '',
    witnessLocation: '',
    witnessOtherLocation: '',
    personInjured: '',
    personInjuredDetails: '',
    damageOnOtherProperties: '',
    consent: false
  });
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(false);

  const sendFormData = () => {
    setApiError(false);
    axios
      .post(Endpoints.ClaimReportDIByggeri, formData)
      .then(() => setSubmitted(true))
      .catch(() => setApiError(true));
  };

  const whoToBlameDropdown = (value: string) => {
    setFormData({ ...formData, whoToBlame: value });
  };

  const dropdownOptions = ['Mig selv', 'Modparten', 'Begge', 'Andet'];
  return (
    <>
      {submitted ? (
        <Alert
          alertType="success"
          showIcon
          title="Tak for din anmeldelse​"
          text="Vi sender dig en kvitteringsmail med informationerne fra din skadeanmeldelse.​"
          className={utils['mb-3']}
        />
      ) : (
        <>
          <div className={utils['pb-2']}>
            <Title tag="h5">Anmeldelse af skade på motorkøretøj</Title>
            <Text size="p">
              Har du brug for hjælp til reparation af glasskade?
              <br />
              <br />
              Dansk Bilglas, tel 70 11 55 55 <br />
              Både Mobilglas, tel 45 88 36 44 <br />I Europa: Carglass, tel +45
              97 20 99 11
              <br />
              <br />
            </Text>
            <Text size="small">* Påkrævede felter</Text>
          </div>
          <Formik
            enableReinitialize
            initialValues={{
              companyName: formData.companyName,
              cvrNumber: formData.cvrNumber,
              contactPersonName: formData.contactPersonName,
              email: formData.email,
              contactPersonPhoneNumber: formData.contactPersonPhoneNumber,
              isMotorVehicleRegistered: formData.isMotorVehicleRegistered,
              registrationNumber: formData.registrationNumber,
              chassisNumber: formData.chassisNumber,
              productAndType: formData.productAndType,
              yearModel: formData.yearModel,
              rescueCorpSubscription: formData.rescueCorpSubscription,
              useAtTimeOfDamage: formData.useAtTimeOfDamage,
              vehiclePartOfVATCompany: formData.vehiclePartOfVATCompany,
              damageDetails: formData.damageDetails,
              damageDateAndTime: formData.damageDateAndTime,
              sceneOfAccidentAddress: formData.sceneOfAccidentAddress,
              policeReportMade: formData.policeReportMade,
              policeStation: formData.policeStation,
              driverTookAlcoholTest: formData.driverTookAlcoholTest,
              driverTookBloodTest: formData.driverTookBloodTest,
              driversNameAndAddress: formData.driversNameAndAddress,
              driversPhoneNumber: formData.driversPhoneNumber,
              driverHadValidDriversLicense:
                formData.driverHadValidDriversLicense,
              driversLicenseNumber: formData.driversLicenseNumber,
              driversLicenseDateOfIssue: formData.driversLicenseDateOfIssue,
              driversLicenseType: formData.driversLicenseType,
              speedOfVehicle: formData.speedOfVehicle,
              wereLightsOn: formData.wereLightsOn,
              wereStreetLightsOn: formData.wereStreetLightsOn,
              accidentSiteInformed: formData.accidentSiteInformed,
              weatherAndDrivingConditions: formData.weatherAndDrivingConditions,
              isVehicleDamaged: formData.isVehicleDamaged,
              vehicleDamageDetails: formData.vehicleDamageDetails,
              otherPartyComeFrom: formData.otherPartyComeFrom,
              wasThereOtherParty: formData.wasThereOtherParty,
              otherPartyDetails: formData.otherPartyDetails,
              otherPartyVehicleDamaged: formData.otherPartyVehicleDamaged,
              otherPartyVehicleDamageDetails:
                formData.otherPartyVehicleDamageDetails,
              otherPartySpeed: formData.otherPartySpeed,
              otherPartyLightsOn: formData.otherPartyLightsOn,
              whoToBlame: formData.whoToBlame,
              witnessToAccident: formData.witnessToAccident,
              witnessLocation: formData.witnessLocation,
              witnessOtherLocation: formData.witnessOtherLocation,
              personInjured: formData.personInjured,
              personInjuredDetails: formData.personInjuredDetails,
              damageOnOtherProperties: formData.damageOnOtherProperties,
              consent: formData.consent
            }}
            validationSchema={validationSchema(formData)}
            onSubmit={() => {
              sendFormData();
            }}
          >
            {(props) => {
              const {
                handleSubmit,
                handleBlur,
                setFieldValue,
                touched,
                errors
              } = props;
              return (
                <form onSubmit={handleSubmit} className={utils['pb-3']}>
                  <Row>
                    <Col lg={12}>
                      <Input
                        id="companyName"
                        labelText="Virksomhedens navn *"
                        name="companyName"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue('companyName', event.target.value);
                          setFormData({
                            ...formData,
                            companyName: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={!!(touched.companyName && errors.companyName)}
                        errorText={errors.companyName}
                        value={formData.companyName}
                      />
                      <Input
                        id="cvr-number"
                        labelText="CVR-nummer *"
                        name="cvrNumber"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue('cvrNumber', event.target.value);
                          setFormData({
                            ...formData,
                            cvrNumber: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={!!(touched.cvrNumber && errors.cvrNumber)}
                        errorText={errors.cvrNumber}
                        value={formData.cvrNumber}
                      />
                      <Input
                        id="contactPersonName"
                        labelText="Navn (kontaktperson) *"
                        name="contactPersonName"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue(
                            'contactPersonName',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            contactPersonName: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.contactPersonName &&
                            errors.contactPersonName
                          )
                        }
                        errorText={errors.contactPersonName}
                        value={formData.contactPersonName}
                      />
                      <Input
                        id="email"
                        labelText="Email (kontaktperson) *"
                        name="email"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue('email', event.target.value);
                          setFormData({
                            ...formData,
                            email: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={!!(touched.email && errors.email)}
                        errorText={errors.email}
                        value={formData.email}
                      />
                      <Input
                        id="contactPersonPhoneNumber"
                        labelText="Telefonnummer (kontaktperson) *"
                        name="contactPersonPhoneNumber"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue(
                            'contactPersonPhoneNumber',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            contactPersonPhoneNumber: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.contactPersonPhoneNumber &&
                            errors.contactPersonPhoneNumber
                          )
                        }
                        errorText={errors.contactPersonPhoneNumber}
                        value={formData.contactPersonPhoneNumber}
                      />
                      <InputGroupSimple
                        vertical
                        header="Er motorkøretøjet indregistreret? *"
                        id="isMotorVehicleRegistered"
                        className={utils['pb-2']}
                        name="isMotorVehicleRegistered"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            isMotorVehicleRegistered: event.target.value
                          });
                          setFieldValue(
                            'isMotorVehicleRegistered',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja, det er indregistreret',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej, det er ikke indregistreret',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.isMotorVehicleRegistered}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.isMotorVehicleRegistered &&
                            errors.isMotorVehicleRegistered
                          )
                        }
                        errorText={errors.isMotorVehicleRegistered}
                      />
                      {formData.isMotorVehicleRegistered === 'Ja' ? (
                        <>
                          <Input
                            id="registrationNumber"
                            labelText="Registreringsnummer *"
                            name="registrationNumber"
                            className={utils['pb-2']}
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setFieldValue(
                                'registrationNumber',
                                event.target.value
                              );
                              setFormData({
                                ...formData,
                                registrationNumber: event.target.value
                              });
                            }}
                            onBlur={handleBlur}
                            invalid={
                              !!(
                                touched.registrationNumber &&
                                errors.registrationNumber
                              )
                            }
                            errorText={errors.registrationNumber}
                            value={formData.registrationNumber}
                          />
                          <Input
                            id="chassisNumber"
                            labelText="Stelnummer / motornummer *"
                            name="chassisNumber"
                            className={utils['pb-2']}
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setFieldValue(
                                'chassisNumber',
                                event.target.value
                              );
                              setFormData({
                                ...formData,
                                chassisNumber: event.target.value
                              });
                            }}
                            onBlur={handleBlur}
                            invalid={
                              !!(touched.chassisNumber && errors.chassisNumber)
                            }
                            errorText={errors.chassisNumber}
                            value={formData.chassisNumber}
                          />
                          <Input
                            id="productAndType"
                            labelText="Fabrikat og type *"
                            name="productAndType"
                            className={utils['pb-2']}
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setFieldValue(
                                'productAndType',
                                event.target.value
                              );
                              setFormData({
                                ...formData,
                                productAndType: event.target.value
                              });
                            }}
                            onBlur={handleBlur}
                            invalid={
                              !!(
                                touched.productAndType && errors.productAndType
                              )
                            }
                            errorText={errors.productAndType}
                            value={formData.productAndType}
                          />
                          <Input
                            id="yearModel"
                            labelText=" Årgang *"
                            name="yearModel"
                            className={utils['pb-2']}
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setFieldValue('yearModel', event.target.value);
                              setFormData({
                                ...formData,
                                yearModel: event.target.value
                              });
                            }}
                            onBlur={handleBlur}
                            invalid={!!(touched.yearModel && errors.yearModel)}
                            errorText={errors.yearModel}
                            value={formData.yearModel}
                          />
                        </>
                      ) : null}
                      <InputGroupSimple
                        vertical
                        header="Har du abonnement hos et redningskorps? *"
                        id="rescueCorpSubscription"
                        className={utils['pb-2']}
                        name="rescueCorpSubscription"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            rescueCorpSubscription: event.target.value
                          });
                          setFieldValue(
                            'rescueCorpSubscription',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.rescueCorpSubscription}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.rescueCorpSubscription &&
                            errors.rescueCorpSubscription
                          )
                        }
                        errorText={errors.rescueCorpSubscription}
                      />
                      <InputGroupSimple
                        vertical
                        header="Anvendelse i skadesøjeblikket *"
                        id="useAtTimeOfDamage"
                        className={utils['pb-2']}
                        name="useAtTimeOfDamage"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            useAtTimeOfDamage: event.target.value
                          });
                          setFieldValue(
                            'useAtTimeOfDamage',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Firmakørsel',
                            value: 'Firmakørsel'
                          },
                          {
                            label: 'Privatkørsel',
                            value: 'Privatkørsel'
                          }
                        ]}
                        type="radio"
                        value={formData.useAtTimeOfDamage}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.useAtTimeOfDamage &&
                            errors.useAtTimeOfDamage
                          )
                        }
                        errorText={errors.useAtTimeOfDamage}
                      />
                      <InputGroupSimple
                        vertical
                        header="Indgår køretøjet i en momsregistreret virksomhed? *"
                        id="vehiclePartOfVATCompany"
                        className={utils['pb-2']}
                        name="vehiclePartOfVATCompany"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            vehiclePartOfVATCompany: event.target.value
                          });
                          setFieldValue(
                            'vehiclePartOfVATCompany',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.vehiclePartOfVATCompany}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.vehiclePartOfVATCompany &&
                            errors.vehiclePartOfVATCompany
                          )
                        }
                        errorText={errors.vehiclePartOfVATCompany}
                      />
                      <div className={utils['pb-2']}>
                        <Title tag="h5">Skaden</Title>
                      </div>
                      <TextArea
                        id="damageDetails"
                        labelText="Beskriv skaden så udførligt som muligt *"
                        maxLength={500}
                        name="damageDetails"
                        className={utils['pb-2']}
                        value={formData.damageDetails}
                        onChange={(
                          event: React.ChangeEvent<HTMLTextAreaElement>
                        ) => {
                          setFieldValue('damageDetails', event.target.value);
                          setFormData({
                            ...formData,
                            damageDetails: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(touched.damageDetails && errors.damageDetails)
                        }
                        errorText={errors.damageDetails}
                      />
                      <Input
                        id="damageDateAndTime"
                        labelText="Dato og tidspunkt for skaden *"
                        placeholder="Dato og klokkeslæt/tidsrum"
                        name="damageDateAndTime"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue(
                            'damageDateAndTime',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            damageDateAndTime: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.damageDateAndTime &&
                            errors.damageDateAndTime
                          )
                        }
                        errorText={errors.damageDateAndTime}
                        value={formData.damageDateAndTime}
                      />
                      <Input
                        id="sceneOfAccidentAddress"
                        labelText="Skadestedets adressse *"
                        name="sceneOfAccidentAddress"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue(
                            'sceneOfAccidentAddress',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            sceneOfAccidentAddress: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.sceneOfAccidentAddress &&
                            errors.sceneOfAccidentAddress
                          )
                        }
                        errorText={errors.sceneOfAccidentAddress}
                        value={formData.sceneOfAccidentAddress}
                      />
                      <InputGroupSimple
                        vertical
                        header="Blev der optaget politirapport? *"
                        id="policeReportMade"
                        className={utils['pb-2']}
                        name="policeReportMade"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            policeReportMade: event.target.value
                          });
                          setFieldValue('policeReportMade', event.target.value);
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.policeReportMade}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.policeReportMade && errors.policeReportMade
                          )
                        }
                        errorText={errors.policeReportMade}
                      />
                      {formData.policeReportMade === 'Ja' && (
                        <Input
                          id="policeStation"
                          labelText="Til hvilken politistation? *"
                          name="policeStation"
                          className={utils['pb-2']}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setFieldValue('policeStation', event.target.value);
                            setFormData({
                              ...formData,
                              policeStation: event.target.value
                            });
                          }}
                          onBlur={handleBlur}
                          invalid={
                            !!(touched.policeStation && errors.policeStation)
                          }
                          errorText={errors.policeStation}
                          value={formData.policeStation}
                        />
                      )}
                      <InputGroupSimple
                        vertical
                        header="Blev føren af dit køretøj aloholtestet (ballon?) *"
                        id="driverTookAlcoholTest"
                        className={utils['pb-2']}
                        name="driverTookAlcoholTest"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            driverTookAlcoholTest: event.target.value
                          });
                          setFieldValue(
                            'driverTookAlcoholTest',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.driverTookAlcoholTest}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.driverTookAlcoholTest &&
                            errors.driverTookAlcoholTest
                          )
                        }
                        errorText={errors.driverTookAlcoholTest}
                      />
                      <InputGroupSimple
                        vertical
                        header="Blev føren af dit køretøj spiritustestet (blodprøve)? *"
                        id="driverTookBloodTest"
                        className={utils['pb-2']}
                        name="driverTookBloodTest"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            driverTookBloodTest: event.target.value
                          });
                          setFieldValue(
                            'driverTookBloodTest',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.driverTookBloodTest}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.driverTookBloodTest &&
                            errors.driverTookBloodTest
                          )
                        }
                        errorText={errors.driverTookBloodTest}
                      />
                      <TextArea
                        id="driversNameAndAddress"
                        labelText="Førers navn og adresse *"
                        maxLength={500}
                        name="driversNameAndAddress"
                        className={utils['pb-2']}
                        value={formData.driversNameAndAddress}
                        onChange={(
                          event: React.ChangeEvent<HTMLTextAreaElement>
                        ) => {
                          setFieldValue(
                            'driversNameAndAddress',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            driversNameAndAddress: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.driversNameAndAddress &&
                            errors.driversNameAndAddress
                          )
                        }
                        errorText={errors.driversNameAndAddress}
                      />
                      <Input
                        id="driversPhoneNumber"
                        labelText="Telefonnummer på føreren *"
                        name="driversPhoneNumber"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue(
                            'driversPhoneNumber',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            driversPhoneNumber: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.driversPhoneNumber &&
                            errors.driversPhoneNumber
                          )
                        }
                        errorText={errors.driversPhoneNumber}
                        value={formData.driversPhoneNumber}
                      />
                      <InputGroupSimple
                        vertical
                        header="Havde føren gyldigt kørekort på skadestidspunktet? *"
                        id="driverHadValidDriversLicense"
                        className={utils['pb-2']}
                        name="driverHadValidDriversLicense"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            driverHadValidDriversLicense: event.target.value
                          });
                          setFieldValue(
                            'driverHadValidDriversLicense',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.driverHadValidDriversLicense}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.driverHadValidDriversLicense &&
                            errors.driverHadValidDriversLicense
                          )
                        }
                        errorText={errors.driverHadValidDriversLicense}
                      />
                      <Input
                        id="driversLicenseNumber"
                        labelText="Kørekortnummer *"
                        name="driversLicenseNumber"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue(
                            'driversLicenseNumber',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            driversLicenseNumber: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.driversLicenseNumber &&
                            errors.driversLicenseNumber
                          )
                        }
                        errorText={errors.driversLicenseNumber}
                        value={formData.driversLicenseNumber}
                      />
                      <Input
                        id="driversLicenseDateOfIssue"
                        labelText="Udstedelsesdato *"
                        name="driversLicenseDateOfIssue"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue(
                            'driversLicenseDateOfIssue',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            driversLicenseDateOfIssue: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.driversLicenseDateOfIssue &&
                            errors.driversLicenseDateOfIssue
                          )
                        }
                        errorText={errors.driversLicenseDateOfIssue}
                        value={formData.driversLicenseDateOfIssue}
                      />
                      <Input
                        id="driversLicenseType"
                        labelText="Kørekorttype *"
                        name="driversLicenseType"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue(
                            'driversLicenseType',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            driversLicenseType: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.driversLicenseType &&
                            errors.driversLicenseType
                          )
                        }
                        errorText={errors.driversLicenseType}
                        value={formData.driversLicenseType}
                      />
                      <Input
                        id="speedOfVehicle"
                        labelText="Din hastighed (km/t) *"
                        name="speedOfVehicle"
                        className={utils['pb-2']}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue('speedOfVehicle', event.target.value);
                          setFormData({
                            ...formData,
                            speedOfVehicle: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(touched.speedOfVehicle && errors.speedOfVehicle)
                        }
                        errorText={errors.speedOfVehicle}
                        value={formData.speedOfVehicle}
                      />
                      <InputGroupSimple
                        vertical
                        header="Var dine lygter tændt? *"
                        id="wereLightsOn"
                        className={utils['pb-2']}
                        name="wereLightsOn"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            wereLightsOn: event.target.value
                          });
                          setFieldValue('wereLightsOn', event.target.value);
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.wereLightsOn}
                        onBlur={handleBlur}
                        invalid={
                          !!(touched.wereLightsOn && errors.wereLightsOn)
                        }
                        errorText={errors.wereLightsOn}
                      />
                      <InputGroupSimple
                        vertical
                        header="Var gadebelysningen tændt? *"
                        id="wereStreetLightsOn"
                        className={utils['pb-2']}
                        name="wereStreetLightsOn"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            wereStreetLightsOn: event.target.value
                          });
                          setFieldValue(
                            'wereStreetLightsOn',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.wereStreetLightsOn}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.wereStreetLightsOn &&
                            errors.wereStreetLightsOn
                          )
                        }
                        errorText={errors.wereStreetLightsOn}
                      />
                      <InputGroupSimple
                        vertical
                        header="Var uheldsstedet oplyst i øvrigt? *"
                        id="accidentSiteInformed"
                        className={utils['pb-2']}
                        name="accidentSiteInformed"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            accidentSiteInformed: event.target.value
                          });
                          setFieldValue(
                            'accidentSiteInformed',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.accidentSiteInformed}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.accidentSiteInformed &&
                            errors.accidentSiteInformed
                          )
                        }
                        errorText={errors.accidentSiteInformed}
                      />
                      <TextArea
                        id="weatherAndDrivingConditions"
                        labelText="Hvordan var vejret og føret? *"
                        maxLength={500}
                        name="weatherAndDrivingConditions"
                        className={utils['pb-2']}
                        value={formData.weatherAndDrivingConditions}
                        onChange={(
                          event: React.ChangeEvent<HTMLTextAreaElement>
                        ) => {
                          setFieldValue(
                            'weatherAndDrivingConditions',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            weatherAndDrivingConditions: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.weatherAndDrivingConditions &&
                            errors.weatherAndDrivingConditions
                          )
                        }
                        errorText={errors.weatherAndDrivingConditions}
                      />
                      <InputGroupSimple
                        vertical
                        header="Er der skader på dit køretøj? *"
                        id="isVehicleDamaged"
                        className={utils['pb-2']}
                        name="isVehicleDamaged"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            isVehicleDamaged: event.target.value
                          });
                          setFieldValue('isVehicleDamaged', event.target.value);
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.isVehicleDamaged}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.isVehicleDamaged && errors.isVehicleDamaged
                          )
                        }
                        errorText={errors.isVehicleDamaged}
                      />
                      {formData.isVehicleDamaged === 'Ja' && (
                        <Input
                          id="vehicleDamageDetails"
                          labelText="Beskriv skaden *"
                          name="vehicleDamageDetails"
                          className={utils['pb-2']}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setFieldValue(
                              'vehicleDamageDetails',
                              event.target.value
                            );
                            setFormData({
                              ...formData,
                              vehicleDamageDetails: event.target.value
                            });
                          }}
                          onBlur={handleBlur}
                          invalid={
                            !!(
                              touched.vehicleDamageDetails &&
                              errors.vehicleDamageDetails
                            )
                          }
                          errorText={errors.vehicleDamageDetails}
                          value={formData.vehicleDamageDetails}
                        />
                      )}
                      <InputGroupSimple
                        vertical
                        header="Var der en modpart? *"
                        id="wasThereOtherParty"
                        className={utils['pb-2']}
                        name="wasThereOtherParty"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            wasThereOtherParty: event.target.value
                          });
                          setFieldValue(
                            'wasThereOtherParty',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.wasThereOtherParty}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.wasThereOtherParty &&
                            errors.wasThereOtherParty
                          )
                        }
                        errorText={errors.wasThereOtherParty}
                      />
                      {formData.wasThereOtherParty === 'Ja' ? (
                        <>
                          <Input
                            id="otherPartyComeFrom"
                            labelText="Hvor kom modparten fra? *"
                            name="otherPartyComeFrom"
                            className={utils['pb-2']}
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setFieldValue(
                                'otherPartyComeFrom',
                                event.target.value
                              );
                              setFormData({
                                ...formData,
                                otherPartyComeFrom: event.target.value
                              });
                            }}
                            onBlur={handleBlur}
                            invalid={
                              !!(
                                touched.otherPartyComeFrom &&
                                errors.otherPartyComeFrom
                              )
                            }
                            errorText={errors.otherPartyComeFrom}
                            value={formData.otherPartyComeFrom}
                          />
                          <TextArea
                            id="otherPartyDetails"
                            labelText="Udfyld med information om modparten *"
                            placeholder="Modpartens registreringsnummer, navn, adresse, telefonnummer, forsikringsselskab"
                            maxLength={500}
                            name="otherPartyDetails"
                            className={utils['pb-2']}
                            value={formData.otherPartyDetails}
                            onChange={(
                              event: React.ChangeEvent<HTMLTextAreaElement>
                            ) => {
                              setFieldValue(
                                'otherPartyDetails',
                                event.target.value
                              );
                              setFormData({
                                ...formData,
                                otherPartyDetails: event.target.value
                              });
                            }}
                            onBlur={handleBlur}
                            invalid={
                              !!(
                                touched.otherPartyDetails &&
                                errors.otherPartyDetails
                              )
                            }
                            errorText={errors.otherPartyDetails}
                          />
                          <InputGroupSimple
                            vertical
                            header="Blev modpartens køretøj beskadiget? *"
                            id="otherPartyVehicleDamaged"
                            className={utils['pb-2']}
                            name="otherPartyVehicleDamaged"
                            centered={false}
                            onChange={(event) => {
                              setFormData({
                                ...formData,
                                otherPartyVehicleDamaged: event.target.value
                              });
                              setFieldValue(
                                'otherPartyVehicleDamaged',
                                event.target.value
                              );
                            }}
                            options={[
                              {
                                label: 'Ja',
                                value: 'Ja'
                              },
                              {
                                label: 'Nej',
                                value: 'Nej'
                              }
                            ]}
                            type="radio"
                            value={formData.otherPartyVehicleDamaged}
                            onBlur={handleBlur}
                            invalid={
                              !!(
                                touched.otherPartyVehicleDamaged &&
                                errors.otherPartyVehicleDamaged
                              )
                            }
                            errorText={errors.otherPartyVehicleDamaged}
                          />
                          {formData.otherPartyVehicleDamaged === 'Ja' && (
                            <TextArea
                              id="otherPartyVehicleDamageDetails"
                              labelText="Beskriv skaderne på modpartens køretøj *"
                              maxLength={500}
                              name="otherPartyVehicleDamageDetails"
                              className={utils['pb-2']}
                              value={formData.otherPartyVehicleDamageDetails}
                              onChange={(
                                event: React.ChangeEvent<HTMLTextAreaElement>
                              ) => {
                                setFieldValue(
                                  'otherPartyVehicleDamageDetails',
                                  event.target.value
                                );
                                setFormData({
                                  ...formData,
                                  otherPartyVehicleDamageDetails:
                                    event.target.value
                                });
                              }}
                              onBlur={handleBlur}
                              invalid={
                                !!(
                                  touched.otherPartyVehicleDamageDetails &&
                                  errors.otherPartyVehicleDamageDetails
                                )
                              }
                              errorText={errors.otherPartyVehicleDamageDetails}
                            />
                          )}
                          <Input
                            id="otherPartySpeed"
                            labelText="Modpartens hastighed (km/t) *"
                            name="otherPartySpeed"
                            className={utils['pb-2']}
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setFieldValue(
                                'otherPartySpeed',
                                event.target.value
                              );
                              setFormData({
                                ...formData,
                                otherPartySpeed: event.target.value
                              });
                            }}
                            onBlur={handleBlur}
                            invalid={
                              !!(
                                touched.otherPartySpeed &&
                                errors.otherPartySpeed
                              )
                            }
                            errorText={errors.otherPartySpeed}
                            value={formData.otherPartySpeed}
                          />
                          <InputGroupSimple
                            vertical
                            header="Var modpartens lygter tændt? *"
                            id="otherPartyLightsOn"
                            className={utils['pb-2']}
                            name="otherPartyLightsOn"
                            centered={false}
                            onChange={(event) => {
                              setFormData({
                                ...formData,
                                otherPartyLightsOn: event.target.value
                              });
                              setFieldValue(
                                'otherPartyLightsOn',
                                event.target.value
                              );
                            }}
                            options={[
                              {
                                label: 'Ja',
                                value: 'Ja'
                              },
                              {
                                label: 'Nej',
                                value: 'Nej'
                              }
                            ]}
                            type="radio"
                            value={formData.otherPartyLightsOn}
                            onBlur={handleBlur}
                            invalid={
                              !!(
                                touched.otherPartyLightsOn &&
                                errors.otherPartyLightsOn
                              )
                            }
                            errorText={errors.otherPartyLightsOn}
                          />
                          <Dropdown
                            name="whoToBlame"
                            id="whoToBlame"
                            labelText="Hvem er efter din mening skyld i uheldet? *"
                            className={utils['pb-2']}
                            options={dropdownOptions.map((option) => {
                              return { labelText: option, value: option };
                            })}
                            value={formData.whoToBlame}
                            onChange={(value) => {
                              whoToBlameDropdown(value);
                              setFieldValue('typeOfDamage', value);
                            }}
                            onBlur={handleBlur}
                            invalid={
                              !!(touched.whoToBlame && errors.whoToBlame)
                            }
                            errorText={errors.whoToBlame}
                          />
                        </>
                      ) : null}
                      <div className={utils['pb-2']}>
                        <Title tag="h5">Vidner</Title>
                      </div>
                      <InputGroupSimple
                        vertical
                        header="Var der vidner til skaden? *"
                        id="witnessToAccident"
                        className={utils['pb-2']}
                        name="witnessToAccident"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            witnessToAccident: event.target.value
                          });
                          setFieldValue(
                            'witnessToAccident',
                            event.target.value
                          );
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.witnessToAccident}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.witnessToAccident &&
                            errors.witnessToAccident
                          )
                        }
                        errorText={errors.witnessToAccident}
                      />
                      {formData.witnessToAccident === 'Ja' && (
                        <>
                          <InputGroupSimple
                            vertical
                            header="Hvor befandt vidnet sig? *"
                            id="witnessLocation"
                            className={utils['pb-2']}
                            name="witnessLocation"
                            centered={false}
                            onChange={(event) => {
                              setFormData({
                                ...formData,
                                witnessLocation: event.target.value
                              });
                              setFieldValue(
                                'witnessLocation',
                                event.target.value
                              );
                            }}
                            options={[
                              {
                                label: 'I mit køretøj',
                                value: 'I mit køretøj'
                              },
                              {
                                label: 'I modpartens køretøj',
                                value: 'I modpartens køretøj'
                              },
                              {
                                label: 'Andet',
                                value: 'Andet'
                              }
                            ]}
                            type="radio"
                            value={formData.witnessLocation}
                            onBlur={handleBlur}
                            invalid={
                              !!(
                                touched.witnessLocation &&
                                errors.witnessLocation
                              )
                            }
                            errorText={errors.witnessLocation}
                          />
                          {formData.witnessLocation === 'Andet' && (
                            <TextArea
                              id="witnessOtherLocation"
                              labelText="Beskriv vidnets placering og evt. kontaktinformation *"
                              maxLength={500}
                              name="witnessOtherLocation"
                              className={utils['pb-2']}
                              value={formData.witnessOtherLocation}
                              onChange={(
                                event: React.ChangeEvent<HTMLTextAreaElement>
                              ) => {
                                setFieldValue(
                                  'witnessOtherLocation',
                                  event.target.value
                                );
                                setFormData({
                                  ...formData,
                                  witnessOtherLocation: event.target.value
                                });
                              }}
                              onBlur={handleBlur}
                              invalid={
                                !!(
                                  touched.witnessOtherLocation &&
                                  errors.witnessOtherLocation
                                )
                              }
                              errorText={errors.witnessOtherLocation}
                            />
                          )}
                        </>
                      )}
                      <InputGroupSimple
                        vertical
                        header="Skete der skade på en person? *"
                        id="personInjured"
                        className={utils['pb-2']}
                        name="personInjured"
                        centered={false}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            personInjured: event.target.value
                          });
                          setFieldValue('personInjured', event.target.value);
                        }}
                        options={[
                          {
                            label: 'Ja',
                            value: 'Ja'
                          },
                          {
                            label: 'Nej',
                            value: 'Nej'
                          }
                        ]}
                        type="radio"
                        value={formData.personInjured}
                        onBlur={handleBlur}
                        invalid={
                          !!(touched.personInjured && errors.personInjured)
                        }
                        errorText={errors.personInjured}
                      />
                      {formData.personInjured === 'Ja' && (
                        <TextArea
                          id="personInjuredDetails"
                          labelText="Beskriv hvem der er kommet til skade og hvordan? *"
                          placeholder="Beskriv skaden samt navn, adresse, telefonnummer på den tilskadekomne"
                          maxLength={500}
                          name="personInjuredDetails"
                          className={utils['pb-2']}
                          value={formData.personInjuredDetails}
                          onChange={(
                            event: React.ChangeEvent<HTMLTextAreaElement>
                          ) => {
                            setFieldValue(
                              'personInjuredDetails',
                              event.target.value
                            );
                            setFormData({
                              ...formData,
                              personInjuredDetails: event.target.value
                            });
                          }}
                          onBlur={handleBlur}
                          invalid={
                            !!(
                              touched.personInjuredDetails &&
                              errors.personInjuredDetails
                            )
                          }
                          errorText={errors.personInjuredDetails}
                        />
                      )}
                      <TextArea
                        id="damageOnOtherProperties"
                        labelText="Hvis der skete skade på andet, kan du beskrive det her"
                        placeholder="Fx skade på vejskilt, autoværn, hegn, hæk, tøj, beplantning og bygning samt erstatningskrav i kr."
                        maxLength={500}
                        name="damageOnOtherProperties"
                        className={utils['pb-2']}
                        value={formData.damageOnOtherProperties}
                        onChange={(
                          event: React.ChangeEvent<HTMLTextAreaElement>
                        ) => {
                          setFieldValue(
                            'damageOnOtherProperties',
                            event.target.value
                          );
                          setFormData({
                            ...formData,
                            damageOnOtherProperties: event.target.value
                          });
                        }}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            touched.damageOnOtherProperties &&
                            errors.damageOnOtherProperties
                          )
                        }
                        errorText={errors.damageOnOtherProperties}
                      />
                      <Checkbox
                        id="consent-id"
                        label="Jeg erklærer herved, at foranstående oplysninger er i overensstemmelse med de faktiske forhold, og at jeg vil yde selskabet enhver assistance i forbindelse med skaden. *"
                        name="consent"
                        type="checkbox"
                        value="consent"
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFieldValue('consent', event.target.checked);
                          setFormData({
                            ...formData,
                            consent: event.target.checked
                          });
                        }}
                        onBlur={handleBlur}
                        className={utils['pb-2']}
                        topAlignInput
                        checked={formData.consent}
                      />
                      {touched.consent && errors.consent && (
                        <>
                          <br />
                          <CustomError errorText={errors.consent} />
                        </>
                      )}
                      <Button variant={'primary'} type="submit" flexible>
                        Send
                      </Button>
                    </Col>
                  </Row>
                </form>
              );
            }}
          </Formik>
        </>
      )}
      {apiError && (
        <Alert
          alertType="error"
          showIcon
          text="Der skete en fejl ved indsendelse. Prøv venligst igen senere"
          title="Der skete en fejl."
          className={utils['mb-3']}
        />
      )}
    </>
  );
};

export default ClaimReportMotorVehicle;
